import { useState, useEffect, useCallback } from "react";
import {
  formatNumberWithCommas,
  parseFormattedNumber,
} from "@marketing-sites/utils/format-number";

export function useFormattedNumberInput(
  value: number,
  options?: { max?: number },
) {
  const max = options?.max;
  const [displayValue, setDisplayValue] = useState("");

  // Sync display value when the actual value changes
  useEffect(() => {
    setDisplayValue(value > 0 ? formatNumberWithCommas(value) : "");
  }, [value]);

  // Handle input changes with formatting
  const handleChange = useCallback(
    (inputValue: string, callback: (val: number) => void) => {
      // Parse the input and clamp to max before formatting
      let numValue = parseFormattedNumber(inputValue);
      if (max !== undefined && numValue > max) numValue = max;
      callback(numValue);

      // Update display value with formatting
      if (inputValue === "" || numValue === 0) {
        setDisplayValue("");
      } else {
        setDisplayValue(formatNumberWithCommas(numValue));
      }
    },
    [max],
  );

  return {
    displayValue,
    handleChange,
  };
}
